import { createRef, FC, useState, useEffect } from 'react';
import { CaretDown } from 'phosphor-react';
import { findSelectedSubcategoryByKey } from '../../../helper/cms';
import { ShopContent, Subcategory } from '../../../types/cms_shared_types';

interface SubcategoryPickerMobileProps {
  selectedSubcategoryKey?: string;
  subcategories: Subcategory[];
  cmsShopContent: ShopContent;
  switchSubcategories: (selectedSubcategoryKey: string) => void;
}

export const SubcategoryPickerMobile: FC<SubcategoryPickerMobileProps> = ({
  selectedSubcategoryKey,
  subcategories,
  cmsShopContent,
  switchSubcategories,
}) => {
  const wrapperRef = createRef<HTMLInputElement>();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <div ref={wrapperRef} className="">
      <button
        id="menu-button"
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="inline-flex justify-center px-4 py-2 border rounded-lg group hover:text-text-gray border-input-border"
      >
        <div className="w-32 mr-2 text-sm font-medium truncate text-sami-dark group-hover:text-text-gray">
          {selectedSubcategoryKey
            ? findSelectedSubcategoryByKey(selectedSubcategoryKey, subcategories)?.name ?? ''
            : cmsShopContent.productChoiceStep.pickSubcategorySelectText}
        </div>
        <CaretDown size={16} weight="bold" className="self-center text-text-gray" />
      </button>

      <div
        hidden={!isOpen}
        role="menu"
        className="absolute z-10 mt-2 origin-top-right bg-white rounded-md shadow-md right-4 ring-1 ring-black ring-opacity-5 focus:outline-none"
      >
        <div>
          {subcategories.map((subcategory, index) => {
            return (
              <div
                key={index}
                onClick={() => {
                  switchSubcategories(subcategory.key);
                  setIsOpen(false);
                }}
                className="flex justify-start px-4 py-3 text-sm truncate text-sami-dark hover:bg-input-gray hover:cursor-pointer"
              >
                {subcategory.name}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
